import { Fragment, useEffect, useState } from 'react'

import Wrapper from '@views/Components/Wrapper'

import { useNavigate, useParams } from 'react-router-dom'
import { ROUTE_LANDING_ZONES_ID_MODE } from '@features/routes'
import { generateUrl } from '@services/routes'

import List from '@views/Landingzones/List'
import Detail from '@views/Landingzones/Detail'
import Migration from '@views/Landingzones/Migration'

export const Landingzones = () => {
    const match = useParams()
    const navigate = useNavigate()

    const [selectedPanel, setSelectedPanel] = useState(<Fragment />)

    useEffect(() => {
        if (match.id) {
            if (!match.mode) return navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, {id: match.id, mode: 'groups'}))
            if (match.mode === 'firewall-migration') setSelectedPanel(<Migration />)
            else setSelectedPanel(<Detail />)
        }
        else setSelectedPanel(<List />)
    }, [match])

    return (
        <Wrapper sx={{padding: 2}}>
            {selectedPanel}
        </Wrapper>
    )
}

export default Landingzones